export const selectByArea = (state) => state.usageStats.byArea;
export const selectByUser = (state) => state.usageStats.byUser;
export const selectIsLoading = (state) => state.usageStats.isLoading;
export const selectError = (state) => state.usageStats.error;
export const selectFilters = (state) => state.usageStats.filters;

export const selectActivityEvents = (state) => state.usageStats.activityEvents;

export const selectActivityIsLoading = (state) =>
  state.usageStats.activityIsLoading;

export const selectActivityError = (state) => state.usageStats.activityError;

export const selectActivitySearch = (state) => state.usageStats.activitySearch;

export const selectActivityIsLoadingMore = (state) =>
  state.usageStats.activityIsLoadingMore;

export const selectActivitySort = (state) => state.usageStats.activitySort;

export const selectActivityHasMore = (state) =>
  state.usageStats.activityHasMore;

export const selectActivityTotal = (state) => state.usageStats.activityTotal;

export const selectActivityFilteredTotal = (state) =>
  state.usageStats.activityFilteredTotal;

export const selectVisiChats = (state) => state.usageStats.visiChats;
export const selectVisiChatsTotal = (state) => state.usageStats.visiChatsTotal;
export const selectVisiChatsIsLoading = (state) =>
  state.usageStats.visiChatsIsLoading;
export const selectVisiChatsHasLoaded = (state) =>
  state.usageStats.visiChatsHasLoaded;
export const selectVisiChatsError = (state) => state.usageStats.visiChatsError;

export const selectAiUsage = (state) => state.usageStats.aiUsage;
export const selectAiUsageIsLoading = (state) =>
  state.usageStats.aiUsageIsLoading;
export const selectAiUsageError = (state) => state.usageStats.aiUsageError;
export const selectAiUsageUser = (state) => state.usageStats.aiUsageUser;
export const selectAiUsageUserOptions = (state) =>
  state.usageStats.aiUsageUserOptions;
export const selectAiUsageAvailability = (state) =>
  state.usageStats.aiUsageAvailability;
export const selectAiUsageAvailabilityResolved = (state) =>
  state.usageStats.aiUsageAvailabilityChecked;

export const selectIsCustomRangeIncomplete = (state) => {
  const { range, from, to } = state.usageStats.filters;
  return range === "custom" && (!from || !to);
};

export const selectTokenUsagePeriod = (state) =>
  state.usageStats.tokenUsage.period;
export const selectTokenUsageSegments = (state) =>
  state.usageStats.tokenUsage.segments;
export const selectTokenUsageDetailsSource = (state) =>
  state.usageStats.tokenUsage.detailsSource;
export const selectTokenUsageQueries = (state) =>
  state.usageStats.tokenUsage.queries;
